import { IAlarmReportMetrics } from '@/interfaces/stores/alarm'
import { formatDate } from '@/utils/date/date-time'

export const formatTotalizerValue = (key: string, value: number | string) => {
  switch (key) {
    case 'day_with_most_alarms':
      return value != null ? formatDate(new Date(`${value}T12:00:00Z`), 'dd/MM/yyyy') : '-'
    default:
      return value
  }
}

export const formatAlarmMetricsTotalizers = (params: IAlarmReportMetrics) => {
  const totalizer: Array<{ value: string | number; label: string }> = []

  const { total_alarms, total_classified_alarms, total_non_classified_alarms, day_with_most_alarms } = params

  totalizer.push({
    value: total_alarms,
    label: 'total_alarms',
  })

  totalizer.push({
    value: total_classified_alarms,
    label: 'total_classified_alarms',
  })

  totalizer.push({
    value: total_non_classified_alarms,
    label: 'total_non_classified_alarms',
  })

  totalizer.push({
    value: formatTotalizerValue('day_with_most_alarms', day_with_most_alarms.day_with_most_alarms),
    label: 'day_with_most_alarms',
  })

  return totalizer
}
